// Weergavelabels en externe zichtbaarheid per ISS 2.0-classificatie.
//
// SPIEGEL van functions/insightStrength/classifyInsight.js, dat hier de BRON is:
// daar wordt de classificatie geproduceerd. Faalt de pariteitstest, pas dan dit
// bestand aan — nooit de backend.
//
// Bewust een eigen bestand zonder imports: src/ en functions/ zijn losse
// npm-pakketten zonder gedeelde modulegrens, dus de enige waarborg is een test
// die beide bestanden leest. Die test kan geen module inladen die `firebase`
// importeert, en daarom staan deze tabellen niet meer in fetchInsightCells.js.
// AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment
// AI-CONTEXT: See functions/insightStrength/issClassificationParity.test.js

/** @type {Object<string, string>} */
export const ISS_CLASSIFICATION_LABELS = {
    sterk_onderbouwd: 'sterk onderbouwd',
    indicatief_nieuw: 'indicatief — nieuw, wordt gevolgd',
    indicatief: 'indicatief',
    opvallend_signaal: 'opvallend signaal (alleen intern)',
    onvoldoende_onderbouwd: 'onvoldoende onderbouwd',
    // Sinds ISS 2026.9: het patroon draaide om in data van ná de ontdekking.
    // Iets anders dan 'onvoldoende onderbouwd' — daar is de grond te dun.
    weerlegd: 'weerlegd in nieuwe data',
    // Sinds ISS 2026.10: groeit wel, maar niet aantoonbaar meer dan bij
    // organisaties die het patroon niet hebben (contrastpoort).
    verschil_niet_aangetoond: 'verschil met organisaties zonder niet aangetoond',
}

/**
 * Classificaties die extern (voor tenants) toonbaar zijn.
 * `opvallend_signaal` is alleen intern; `onvoldoende_onderbouwd`, `weerlegd` en
 * `verschil_niet_aangetoond` zijn niet toonbaar.
 * @type {Array<string>}
 */
export const ISS_EXTERNAL_CLASSIFICATIONS = ['sterk_onderbouwd', 'indicatief_nieuw', 'indicatief']
